<div class="ui grid">
  <div class="row">
    <div class="column">
      <h1 class="ui header" i18n="@@author-create-article">Artikel erstellen:</h1>
      <app-article-form [topics]="topics" [subjectAreas]="subjectAreas" [institutions]="institutions"
                        #articleFormComponent></app-article-form>
    </div>
  </div>
  <div class="row">
    <div class="column privacy-note" i18n="@@author-privacy-note">
      Als Subadmin/Author erklären Sie sich damit einverstanden, dass Ihr Vor- und Nachname sowie Ihre E-Mail-Adresse anderen Subadmins und Autor*innen in Artikellisten angezeigt werden.
      Dies dient der Nachvollziehbarkeit, wer Artikel erfasst.
      Ab sofort haben alle Subadmins das Recht, alle Artikel einer Institution zu bearbeiten.
      Eine Weitergabe Ihrer Daten an Personen außerhalb der FIT-Datenbank findet nicht statt.
      Weitere Informationen zum Datenschutz finden Sie in unserer <a routerLink="/privacy">Datenschutzerklärung</a>.
    </div>
  </div>
  <div class="row">
    <div class="column">
      <button
        type="submit"
        class="ui primary button"
        [disabled]="!articleFormComponent.articleForm.valid"
        (click)="createArticle(false)"
        i18n="@@author-create"
      >
        Erstellen
      </button>
      <button
        type="submit"
        class="ui yellow button"
        (click)="createArticle(true)"
        [disabled]="articleFormComponent.articleForm.controls.title.invalid"
        i18n="@@author-create-draft"
      >
        Als Entwurf speichern
      </button>
    </div>
  </div>
  <div class="row">
    <div class="column">
      <div i18n="@@author-necessary">* erforderlich</div>
      <div i18n="@@author-necessary-not-permanent">** erforderlich, außer bei dauerhafter Ausschreibung</div>
    </div>
  </div>
</div>

